import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../contexts/ThemeContext';

const WelcomeHeader = () => {
  const { isDark } = useTheme();

  return (
    <div className="text-center mb-8">
      {/* Logo */}
      <Link to="/" className="inline-flex flex-col items-center space-y-3 mb-6">
        {/* Logo image - transparent PNG, theme-aware background */}
        <div
          className="relative flex items-center justify-center rounded-2xl"
          style={{
            width: '140px',
            height: '140px',
            background: isDark
              ? 'linear-gradient(135deg, #1A2840 0%, #0F1923 100%)'
              : 'linear-gradient(135deg, #EBF4FF 0%, #DBEAFE 100%)',
            boxShadow: isDark
              ? '0 8px 32px rgba(91,155,213,0.18)'
              : '0 8px 32px rgba(46,111,216,0.15)',
          }}
        >
          <img
            src={isDark
              ? "/assets/images/PrimeOnePlus_icon_dark_transparent-1773243102921.png" :"/assets/images/PrimeOnePlus_icon_light_transparent-1773242794502.png"
            }
            alt="PrimeOne+ logo"
            style={{
              width: '110px',
              height: '110px',
              objectFit: 'contain',
              filter: isDark ? 'brightness(1.15) drop-shadow(0 2px 8px rgba(91,155,213,0.4))' : 'none',
            }}
          />
        </div>
        <span className="text-2xl font-bold text-foreground">PrimeOne+</span>
      </Link>

      {/* Welcome Message */}
      <div className="space-y-2">
        <h1 className="text-3xl font-bold text-foreground">
          Welcome Back
        </h1>
        <p className="text-muted-foreground text-lg">
          Continue your wellness journey with personalized health tracking
        </p>
      </div>

      {/* Demo Credentials Info */}
      <div className="mt-6 p-4 bg-accent/10 rounded-lg border border-accent/20">
        <div className="flex items-center justify-center space-x-2 mb-2">
          <span className="text-sm font-medium text-accent">Demo Account</span>
        </div>
        <p className="text-xs text-muted-foreground">
          Use <strong>demo@vitaltracker.com</strong> / <strong>demo123</strong> to explore the app
        </p>
      </div>
    </div>
  );
};

export default WelcomeHeader;